import * as React from "react";
import type { SVGProps } from "react";
const SvgBancontact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fff"
      d="M2.688 5h18.624a.69.69 0 0 1 .688.688v12.393a.69.69 0 0 1-.689.688H2.688A.69.69 0 0 1 2 18.081V5.688A.69.69 0 0 1 2.688 5"
    />
    <path
      fill="#1e3764"
      d="M3.781 16.948v-2.375h.733c.532 0 .875.2.875.614a.55.55 0 0 1-.261.492.59.59 0 0 1 .35.567c0 .478-.35.702-.893.702zm.472-1.388h.349c.214 0 .305-.105.305-.298 0-.207-.166-.275-.39-.275h-.264zm0 .974h.291c.285 0 .451-.071.451-.295 0-.22-.142-.312-.41-.312h-.332zm2.138.455c-.464 0-.698-.228-.698-.533 0-.336.274-.532.681-.536q.153.003.302.027v-.081c0-.207-.118-.306-.346-.306a1.2 1.2 0 0 0-.447.082l-.085-.366a1.7 1.7 0 0 1 .587-.102c.498 0 .746.264.746.722v.943c-.14.072-.4.15-.74.15m.285-.384v-.363a1 1 0 0 0-.24-.027c-.157 0-.279.061-.279.22 0 .143.102.218.282.218a.5.5 0 0 0 .237-.048m.784.343v-1.625c.244-.098.504-.149.767-.15.495 0 .78.245.78.696v1.079H8.54v-1.045c0-.234-.108-.343-.315-.343a.7.7 0 0 0-.299.062v1.326zm3.183-1.672-.088.37a1 1 0 0 0-.383-.086c-.275 0-.424.194-.424.513 0 .35.156.529.447.529a1 1 0 0 0 .377-.088l.075.376a1.14 1.14 0 0 1-.489.099c-.563 0-.889-.35-.889-.903 0-.55.323-.912.862-.912.176-.001.35.034.512.102m1.011 1.713c-.522 0-.848-.363-.848-.91 0-.542.326-.905.848-.905.526 0 .845.363.845.906 0 .546-.319.909-.845.909m0-.387c.241 0 .367-.2.367-.523 0-.318-.126-.519-.367-.519-.237 0-.37.2-.37.52 0 .322.133.522.37.522m1.116.346v-1.625c.244-.098.504-.149.767-.15.495 0 .78.245.78.696v1.079h-.468v-1.045c0-.234-.109-.343-.316-.343a.7.7 0 0 0-.298.062v1.326zm2.602.04c-.403 0-.61-.22-.61-.668v-.732h-.23v-.373h.23v-.377l.468-.024v.4h.377v.374h-.377v.726c0 .196.081.288.234.288q.09 0 .18-.02l.024.376a1.3 1.3 0 0 1-.296.03m1.182 0c-.465 0-.699-.227-.699-.532 0-.336.275-.532.682-.536q.152.003.302.027v-.081c0-.207-.119-.306-.346-.306a1.2 1.2 0 0 0-.448.082l-.085-.366a1.7 1.7 0 0 1 .587-.102c.499 0 .747.264.747.722v.943c-.14.072-.4.15-.74.15m.285-.383v-.363a1 1 0 0 0-.24-.027c-.157 0-.28.061-.28.22 0 .143.103.218.283.218a.5.5 0 0 0 .237-.048m2.056-1.33-.088.37a1 1 0 0 0-.383-.085c-.275 0-.424.194-.424.513 0 .35.155.529.447.529a1 1 0 0 0 .377-.088l.074.376a1.14 1.14 0 0 1-.488.099c-.563 0-.889-.35-.889-.903 0-.55.322-.912.862-.912.176-.001.35.034.512.102m1.03 1.714c-.404 0-.611-.22-.611-.669v-.732h-.231v-.373h.23v-.377l.469-.024v.4h.376v.374h-.376v.726c0 .196.081.288.234.288q.09 0 .18-.02l.023.376a1.3 1.3 0 0 1-.295.03"
    />
    <path
      fill="url(#bancontact_svg__a)"
      d="M7.046 13.386c2.477 0 3.716-1.651 4.954-3.302H3.781v3.302z"
    />
    <path
      fill="url(#bancontact_svg__b)"
      d="M16.954 6.78c-2.477 0-3.716 1.652-4.954 3.304h8.22V6.78z"
    />
    <defs>
      <linearGradient
        id="bancontact_svg__a"
        x1={5.443}
        x2={11.456}
        y1={11.887}
        y2={9.654}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005ab9" />
        <stop offset={1} stopColor="#1e3764" />
      </linearGradient>
      <linearGradient
        id="bancontact_svg__b"
        x1={12.498}
        x2={18.882}
        y1={10.37}
        y2={8.192}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fba900" />
        <stop offset={1} stopColor="#ffd800" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgBancontact;
